import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { getCidade, deleteCidade } from '../../services/apiCidade';
import { erroToastify } from '../../shared/validacaoToastify';
import SelectGenerico from '../../components/selectGenerico/selectGenerico';
import InputGenerico from '../../components/inputGenerico/inputGenerico';
import { ToastContainer } from "react-toastify";
import "./cidade.css";
import "react-toastify/dist/ReactToastify.css";
import { CamposPadroes } from '../../shared/CamposPadroes';
import ModalDeConfirmacao from '../../components/modal/modalDeConfirmacao/modalDeConfirmacao';
import { Helmet } from "react-helmet";

function ExcluirCidade() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [cidade, setCidade] = useState<any>({});
    const [showConfirmation, setShowConfirmation] = useState(false);

    useEffect(() => {
        fetchCidadeParaExcluir();
    }, []);

    const fetchCidadeParaExcluir = async () => {
        try {
            const response = await getCidade(id || '');
            setCidade(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleExcluir = async () => {
        try {
            const dataPresente = new Date();
            const dataParaAtualizar = {
                cdCidade: cidade.cdCidade,
                nmCidade: cidade.nmCidade,
                cdUf: cidade.cdUf,
                ...CamposPadroes.toObjeto(1, 1, dataPresente.toISOString(), dataPresente.toISOString(), false)
            }
            await deleteCidade(dataParaAtualizar);
            const successMessage = "A cidade foi excluída com sucesso!";
            navigate(`/milshop/consultar/cidades?successMessage=${encodeURIComponent(successMessage)}`);
        } catch (error: any) {
            if (error.response.data) {
                erroToastify(error.response.data);
            }
        }
    }

    const handleConfirmExclusao = () => {
        setShowConfirmation(true);
    }

    const cancelarExclusao = () => {
        setShowConfirmation(false);
    }

    return (
      <>
      <Helmet>
        <title>Excluir cidade</title>
      </Helmet>
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6 bg-light rounded shadow p-4">
                    <form className='mb-3' onSubmit={(e) => { e.preventDefault(); handleConfirmExclusao(); }}>
                        <SelectGenerico
                            opcoes={[{
                                valor: cidade.cdUf,
                                rotulo: `(${cidade.nmSigla}) ${cidade.nmUf}`,
                            }]}
                            valorSelecionado={cidade.cdUf}
                            label="Estado"
                            mensagemError="Não há Estados a serem listados"
                            classe={`selectUf form-select mb-3 cursorBlock`}
                            onChange={() => { }}
                            disabled={true}
                        />
                        <InputGenerico
                            name="nomeCidade"
                            label="Nome da Cidade"
                            value={cidade.nmCidade}
                            className={`form-control cursorBlock`}
                            disabled={true}
                            type="text"
                        />
                        <div className="d-flex mt-4">
                            <a className="btn btn-outline-danger me-2 btn-sm" href="/milshop/consultar/cidades" role="button" style={{ width: "100px" }}>Cancelar</a>
                            <button type="submit" className="btn btn-outline-warning btn-sm" style={{ width: "100px" }}>Excluir</button>
                        </div>
                    </form>
                </div>
            </div>
            <ModalDeConfirmacao
                showConfirmation={showConfirmation}
                confirmExclusao={handleExcluir}
                cancelarExclusao={cancelarExclusao}
                textoExclusao='Deseja realmente excluir esta cidade?'
            />
            <ToastContainer />
        </div>
        </>
    );
}

export default ExcluirCidade;
